module.exports = __webpack_public_path__ + "img/full6-min.90427e31.png";